import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from './providers/QueryProvider';
import App from './App';
import { captureAttribution } from './utils/marketing/attribution';
import './styles/index.scss';
import './i18n';

// Before the first render: redirects (e.g. / → /login) drop the query string.
captureAttribution();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </QueryProvider>
  </React.StrictMode>
);
